'use client'

import classNames from 'clsx'
import { ComponentPropsWithoutRef, forwardRef } from 'react'

import S from '../Table.module.scss'

export interface TableBodyProps extends ComponentPropsWithoutRef<'tbody'> {}

export const TableBody = forwardRef<HTMLTableSectionElement, TableBodyProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <tbody {...props} ref={ref} className={classNames(S.body, className)}>
        {children}
      </tbody>
    )
  }
)

TableBody.displayName = 'Table.Body'
